import React from "react";

const UrinaryTractInfection = () => {
  return (
    <div className="bg-white p-6  flex flex-col max-w-[464px] ">
      <p className="text-teal-300  text-left text-body-sm mt-2.5 font-normal">
        Acute uncomplicated cystitis is most commonly caused by Escherichia coli
        (75-95%), with the remainder caused by Staphylococcus species, Proteus
        mirabilis, and Klebsiella pneumonia
      </p>
    </div>
  );
};

export default UrinaryTractInfection;
